import _extends from 'babel-runtime/helpers/extends';

import isStringOrStringArray from '@/utils/isStringOrStringArray';

export default {
  name: 'DeveloperSelector',

  componentName: 'DeveloperSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    developers: function developers() {
      var _this = this;

      return this.$store.getters.developer.map(function (item) {
        return {
          value: isStringOrStringArray(_this.formValue[_this.innerConfig.prop]) ? String(item.id) : Number(item.id), // 兼容传入参数的类型
          label: item.real_name
        };
      });
    },
    innerConfig: function innerConfig() {
      var params = _extends({
        clearable: true,
        placeholder: '请选择研发'
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  mounted: function mounted() {
    if (this.developers && !this.developers.length) {
      this.$store.dispatch('GetDeveloper');
    }
  }
};